<div class="transcript-block" [attr.data-block-id]="block.id">
  <div class="transcript-block__header">
    <span class="transcript-block__timestamp">{{ block.timestamp }}</span>
    <div class="transcript-block__actions">
      <button type="button" class="transcript-block__action-btn" (click)="goToIn.emit(block.startTimeMs)">
        Go to IN
      </button>
      <button type="button" class="transcript-block__action-btn" (click)="goToOut.emit(block.endTimeMs)">
        Go to Out
      </button>
    </div>
  </div>
  <p class="transcript-block__text">{{ block.text }}</p>
</div>
